
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemExDtDialog extends Serenity.EntityDialog<Adv05ItemExDtRow, any> {
        protected getFormKey() { return Adv05ItemExDtForm.formKey; }
        protected getIdProperty() { return Adv05ItemExDtRow.idProperty; }
        protected getLocalTextPrefix() { return Adv05ItemExDtRow.localTextPrefix; }
        protected getNameProperty() { return Adv05ItemExDtRow.nameProperty; }
        protected getService() { return Adv05ItemExDtService.baseUrl; }
        protected getDeletePermission() { return Adv05ItemExDtRow.deletePermission; }
        protected getInsertPermission() { return Adv05ItemExDtRow.insertPermission; }
        protected getUpdatePermission() { return Adv05ItemExDtRow.updatePermission; }

        protected form = new Adv05ItemExDtForm(this.idPrefix);

    }
}